import * as FlipdishApi from '@flipdish/api-client-typescript';
import $ from 'jquery';
import * as React from 'react';
import * as Api from '../../Api';
import * as BasketControl from '../../BasketControl';
import { COLLAPSE_TIME, SCROLL_TIME } from '../../constants/Constants';
import * as Routes from '../../Routes';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import LoadingPanel from '../LoadingPanel';
import MenuHeader from '../MenuHeader/index.weborder';
import MenuSection from '../MenuSection';

const tinycolor = require('tinycolor2');
const uuidv4 = require('uuid/v4');

//Needed to address browser inconsistencies
window['__forceSmoothScrollPolyfill__'] = true;
require('smoothscroll-polyfill').polyfill();

interface Props {
  ClearFlipdishStore?: () => any;
  HandleClickItem: (payload: { menuId: number; item: Api.MenuItem }) => any;
  vrid: number;
  menu: Api.MenuReposnse | Api.ReadonlyMenuResponse | null;
  Basket: BasketControl.Data;
  AddItemToBasket: (payload: BasketControl.Item) => void;
  RemoveItemAt: (payload: { menuId: number; index: number; indexName?: string }) => void;
  Restaurant: Routes.RouteRestaurant;
  ExpandedState: number[];
  InitializeExpandedState: (vrid: number, expandedState: number[]) => any;
  AddToExpandedState: (vrid: number, menuSectionId: number) => any;
  RemoveFromExpandedState: (vrid: number, menuSectionId: number) => any;
  translate: any;
  Languages: Store.Language[];
  InsideDeliveryZone: boolean;
  AppDesignScheme: Api.AppDesignScheme;
  isDark: boolean;
  concessionStoreId?: number;
}

class Menu extends React.Component<Props, {}> {
  public clearFlipdishStore() {
    if (this.props.ClearFlipdishStore) {
      this.props.ClearFlipdishStore();
    }
  }

  public UNSAFE_componentWillMount() {
    this.setupExpandedStates(this.props);
  }

  public UNSAFE_componentWillReceiveProps(newProps: Props) {
    this.setupExpandedStates(newProps);
  }

  private setupExpandedStates(props: Props) {
    const { ExpandedState, Restaurant, InitializeExpandedState, vrid, menu } = props;

    if (!menu) {
      return;
    }

    switch (Restaurant.status) {
      case 'pending':
        return;
      case 'none':
      default:
        break;
    }

    if (typeof ExpandedState === 'undefined') {
      let expandedSections = [];

      for (const menuSection of menu.MenuSections) {
        if (Restaurant.status != 'none' && menuSection.MenuSectionAvailability) {
          switch (menuSection.MenuSectionAvailability.AvailabilityMode) {
            case Api.MenuEntityAvailabilityMode.DisplayAlways:
              expandedSections.push(menuSection.MenuSectionId);
              break;
            case Api.MenuEntityAvailabilityMode.DisplayBasedOnTimes:
              if (
                menuSection.MenuSectionAvailability.AvailableTimes != null &&
                Utilities.isInPeriod(
                  menuSection.MenuSectionAvailability.AvailableTimes,
                  Restaurant.data.TimeZoneInfoId
                )
              ) {
                expandedSections.push(menuSection.MenuSectionId);
              }
              break;
            case Api.MenuEntityAvailabilityMode.DisplayAlwaysStartCollapsedBasedOnTimes:
              if (
                menuSection.MenuSectionAvailability.AvailableTimes != null &&
                Utilities.isInPeriod(
                  menuSection.MenuSectionAvailability.AvailableTimes,
                  Restaurant.data.TimeZoneInfoId
                )
              ) {
                expandedSections.push(menuSection.MenuSectionId);
              }
              break;
          }
        } else {
          expandedSections.push(menuSection.MenuSectionId);
        }
      }

      if (menu.MenuSectionBehaviour === Api.MenuSectionBehaviour.ExpandSingle) {
        expandedSections = expandedSections.slice(0, 1);
      }

      InitializeExpandedState(vrid, expandedSections);
    }

    //Toggle MenuSectionBehaviour
    if (this.props.menu && menu.MenuSectionBehaviour != this.props.menu.MenuSectionBehaviour) {
      if (menu.MenuSectionBehaviour === Api.MenuSectionBehaviour.ExpandSingle) {
        const newExpandedSections = ExpandedState.slice(-1);
        InitializeExpandedState(vrid, newExpandedSections);
      }
    }
  }

  private menuMessage = (): JSX.Element | null => {
    const { Restaurant, AppDesignScheme } = this.props;

    const styles = {
      secondary: {
        color: AppDesignScheme.Secondary
      },
      message: {
        borderColor: tinycolor(AppDesignScheme.Secondary)
          .darken(20)
          .toString()
      }
    };

    switch (Restaurant.status) {
      case 'none':
      case 'pending':
        return null;
      default:
        if (!Restaurant.data.MenuMessage) {
          return null;
        } else {
          const menuMessageWithLineBreaks = Utilities.stringToJSX(
            Restaurant.data.MenuMessage.split('\n'),
            (part: string) => [part, <br key={uuidv4()} />]
          );
          menuMessageWithLineBreaks.pop();

          return (
            <div
              className="menu__message flex flex-align-center flex-justify-center"
              style={styles.message}
            >
              <i
                className="fa fa-info-circle secondary"
                style={styles.secondary}
                aria-hidden="true"
              />
              <p className="secondary clear-margins fd-h5" style={styles.secondary}>
                {menuMessageWithLineBreaks}
              </p>
            </div>
          );
        }
    }
  };

  private sectionLinksScroll = (offsetTime: number, menuSectionId: number): any => {
    const section = document.getElementById(`${menuSectionId}`);

    const offset: string | null = Utilities.extraOption('data-offset') || '0';

    let offsetInt = 0;

    if (offset) {
      offsetInt = parseInt(offset);
    }

    const scrollableContainerId = Utilities.extraOption('data-scrollable-container');

    if (section) {
      if (scrollableContainerId) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: 'smooth' });
        }, offsetTime);

        setTimeout(() => {
          section.scrollIntoView({ behavior: 'smooth' });
        }, SCROLL_TIME + COLLAPSE_TIME + offsetTime);
      } else {
        //Scroll down to element
        setTimeout(() => {
          $('html, body').animate(
            {
              scrollTop: $(section).offset().top - offsetInt
            },
            SCROLL_TIME
          );
        }, offsetTime);

        //After expanding scroll again to adjust if need be
        setTimeout(() => {
          const bodyScroll = $('body').scrollTop();
          const elementOffset = Math.round($(section).offset().top);

          if (bodyScroll != elementOffset) {
            $('html, body').animate(
              {
                scrollTop: elementOffset - offsetInt
              },
              SCROLL_TIME
            );
          }
        }, SCROLL_TIME + COLLAPSE_TIME + offsetTime);
      }
    }
  };

  public render(): JSX.Element | null {
    const { Restaurant, InsideDeliveryZone, AppDesignScheme, menu } = this.props;

    if (!menu) {
      if (!InsideDeliveryZone) {
        return null;
      }

      return <LoadingPanel AppDesignScheme={AppDesignScheme} />;
    }

    switch (Restaurant.status) {
      case 'pending':
        return <LoadingPanel AppDesignScheme={AppDesignScheme} />;
      case 'none':
      default:
        break;
    }

    const Currency =
      Restaurant.status === 'success' && Restaurant.data.Currency
        ? Restaurant.data.Currency
        : Api.Currency.EUR;

    const menuSections: JSX.Element[] = [];

    for (let idx = 0; idx < menu.MenuSections.length; idx++) {
      const menuSection = menu.MenuSections[idx];

      //Hacky fix for now
      if (
        menuSection.Name === 'Hidden Promotional Items' ||
        (this.props.concessionStoreId &&
          this.props.concessionStoreId != menuSection.ConcessionStoreId)
      ) {
        continue;
      }

      menuSections.push(
        <MenuSection
          key={menuSection.MenuSectionId}
          Currency={Currency}
          Items={menuSection.MenuItems}
          MenuSectionId={menuSection.MenuSectionId}
          Name={menuSection.Name}
          DisplayOrder={menuSection.DisplayOrder}
          Basket={this.props.Basket}
          IsAvailable={menuSection.IsAvailable}
          HandleClickItem={this.props.HandleClickItem}
          Description={menuSection.Description}
          MenuSectionAvailability={menuSection.MenuSectionAvailability}
          RemoveItemAt={this.props.RemoveItemAt}
          AddItemToBasket={this.props.AddItemToBasket}
          Restaurant={this.props.Restaurant}
          ImageUrl={menuSection.ImageUrl}
          MenuSectionBehaviour={menu.MenuSectionBehaviour}
          ExpandedState={this.props.ExpandedState}
          InitializeExpandedState={this.props.InitializeExpandedState}
          AddToExpandedState={this.props.AddToExpandedState}
          RemoveFromExpandedState={this.props.RemoveFromExpandedState}
          vrid={this.props.vrid}
          EditMode={false}
          HideHidden={false}
          MenuId={menu.MenuId}
          translate={this.props.translate}
          Languages={this.props.Languages}
          AppDesignScheme={this.props.AppDesignScheme}
          isDark={this.props.isDark}
        />
      );
    }

    return (
      <div className="menu">
        {this.menuMessage()}
        <MenuHeader
          SectionLinksScroll={this.sectionLinksScroll}
          Restaurant={this.props.Restaurant}
          ExpandedState={this.props.ExpandedState}
          InitializeExpandedState={this.props.InitializeExpandedState}
          AddToExpandedState={this.props.AddToExpandedState}
          vrid={this.props.vrid}
          translate={this.props.translate}
          menu={menu}
          AppDesignScheme={this.props.AppDesignScheme}
          isDark={this.props.isDark}
          concessionStoreId={this.props.concessionStoreId}
        />
        {menuSections}
      </div>
    );
  }
}

export default Menu;
